const trackPopupEvent = url =>
  window.gtag?.('event', 'Identification', {
    event_category: 'Identificate object',
    event_label: url
  });

export default trackPopupEvent;
